import Glide from '@glidejs/glide/dist/glide.js';
import LazyLoad from 'vanilla-lazyload';

/**
 * Slider
 * @class
 * @constructor
 * @public
 */
class Gallery {
  /**
   * Constructor
   * @returns {object} options The options
   * @returns {class}
   */
  constructor() {
    this.components = document.querySelectorAll('[data-gallery]');

    // Engage engines
    if (this.components) {
      this.components.forEach((component) => {
        this.preloadImages(component);
        this.init(component);
      });
    }
  }

  /**
   * Initialize the component
   * @returns {void}
   */
  init(component) {
    const options = JSON.parse(component.getAttribute('data-gallery'));

    const slider = new Glide(component, {
      type: 'carousel',
      gap: 32,
      dragThreshold: 10,
      autoplay: options.autoplay ? 4000 : false,
      perView: options.perView || 1,
      peek: {
        before: 0,
        after: options.peek ? 120 : 0
      },
      breakpoints: {
        575: {
          gap: 20,
          perView: 1,
          peek: {
            before: 0,
            after: options.peek ? 80 : 0
          }
        }
      }
    }).mount();

  }

  /**
   * Preload images on current component
   * @returns {void}
   */
  preloadImages(component) {
    const ll = new LazyLoad({
      container: component,
      elements_selector: '[data-srcset]',
    });
    ll.loadAll();
  }

}

module.exports = Gallery;
